import { BrowserRouter, Routes, Route } from "react-router-dom";
import SharpSprintRouter from "../learning_features/SharpSprintRouter";
import { css } from "@emotion/css";

/**
 * SharpSprint component acts as the main entry point for the learning feature
 * It sets up the router and renders the SharpSprintRouter component which manages
 * the WebSocket connection and routing between different learning views
 */
export const SharpSprint = () => {

  const wrapperStyle = css`
    width: 100%;
    height: 100%;
  `;

  return (
    <div className={wrapperStyle}>
      {/* Use BrowserRouter at this level to create a scoped router for the learning feature */}
      <Routes>
        <Route path="/*" element={<SharpSprintRouter />} />
      </Routes>
    </div>
  );
};
